import { render } from "./Accordion.vue?vue&type=template&id=30a95abe&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=30a95abe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a95abe"],['__file',"src/components/Accordion/Accordion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30a95abe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30a95abe', __exports__)) {
    api.reload('30a95abe', __exports__)
  }
  
  module.hot.accept("./Accordion.vue?vue&type=template&id=30a95abe&scoped=true", () => {
    api.rerender('30a95abe', render)
  })

}


export default __exports__